/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/243-shocked2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM5 7c-.552 0-1-.672-1-1.5S4.448 4 5 4s1 .672 1 1.5S5.552 7 5 7zm3 6a2 2 0 11-.001-3.999A2 2 0 018 13zm3-6c-.552 0-1-.672-1-1.5S10.448 4 11 4s1 .672 1 1.5S11.552 7 11 7z"/>'
  }
})
